import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import appStore from '@/assets/images/wreg/market-appstore.svg';
import googlePlay from '@/assets/images/wreg/market-google.svg';
import { chatBotManager } from '@/services/chatBotManager';
import { WregPhase } from '../WregPhase';
import { wregStepNumber } from '../wregSteps';
import { SELECT_DOWNLOAD_APP } from '@/consts/events';
import type { WregScreenEvent } from './wregScreenEvents';

type Props = {
  onEnter: () => void;
  onEvent?: WregScreenEvent;
};

const STEPS = [
  ['wreg.allset.item1', 'wreg.allset.item1_sub'],
  ['wreg.allset.item2', 'wreg.allset.item2_sub'],
  ['wreg.allset.item3', 'wreg.allset.item3_sub'],
] as const;

const BENEFITS = ['wreg.allset.benefit1', 'wreg.allset.benefit2'] as const;

const WregAllSet = ({ onEnter, onEvent }: Props) => {
  const { t } = useTranslation();
  const download = (store: 'app_store' | 'google_play') => () => {
    onEvent?.(SELECT_DOWNLOAD_APP, { store });
    onEnter();
  };

  useEffect(() => {
    chatBotManager.setWidgetVisibility(false);
    return () => chatBotManager.setWidgetVisibility(true);
  }, []);

  return (
    <div className="rg-screen">
      <div className="rg-body">
        <div className="rg-inner" style={{ alignItems: 'stretch' }}>
          <div className="rg-head-block">
            <WregPhase n={wregStepNumber('allset')} />
            <h1 className="rg-h1">{t('wreg.allset.title')}</h1>
            <p className="rg-sub rg-handoff-intro">{t('wreg.allset.sub')}</p>
          </div>
          <ol className="rg-handoff-list">
            {STEPS.map(([titleKey, detailKey], index) => (
              <li className="rg-handoff-item" key={titleKey}>
                <span className="rg-handoff-step-number" aria-hidden="true">
                  {index + 1}
                </span>
                <span className="rg-handoff-copy">
                  <strong>{t(titleKey)}</strong>
                  <span>{t(detailKey)}</span>
                </span>
              </li>
            ))}
          </ol>
          <div className="rg-store-row">
            <button
              type="button"
              className="dsb dsb-store dsb-m dsb-block"
              onClick={download('app_store')}
            >
              <img src={appStore} alt={t('wreg.allset.appstore')} width="150" height="39" />
            </button>
            <button
              type="button"
              className="dsb dsb-store dsb-m dsb-block"
              onClick={download('google_play')}
            >
              <img src={googlePlay} alt={t('wreg.allset.googleplay')} width="174" height="42" />
            </button>
          </div>
          <section className="rg-app-benefits" aria-labelledby="rg-app-benefits-title">
            <h2 id="rg-app-benefits-title">{t('wreg.allset.benefits_title')}</h2>
            <ul>
              {BENEFITS.map((key) => (
                <li key={key}>{t(key)}</li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export { WregAllSet };
